function v(i, e) {
  Object.entries(e).forEach(([t, s]) => {
    i.addEventListener(t, s);
  });
}
function A(i, e) {
  Object.entries(e).forEach(([t, s]) => {
    i.removeEventListener(t, s);
  });
}
function I(i, e, t) {
  return t = e < t ? e : t, t = t < i ? i : t, t;
}
function m(i) {
  const e = new URL(i);
  return new URLSearchParams(e.hash.slice(1));
}
function p(i) {
  return `#${i.toString()}`;
}
function d(i) {
  if (window.location.host.match(/^admin[\-a-z0-9]*\.imaios\.com$/))
    return "";
  const e = window.location.pathname.split("/")[1];
  return e !== void 0 && (e.length === 2 || e === "admin" || e.startsWith("test_")) ? e : i ?? "";
}
function y(i = "en") {
  const e = d(i);
  switch (e) {
    case "br":
      return "pt";
    case "cn":
      return "zh";
    case "jp":
      return "ja";
    default:
      return e;
  }
}
const g = 3e5;
class r {
  static store = localStorage;
  isAvailable = !1;
  constructor() {
    this.isAvailable = r.checkIsAvailable();
  }
  // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available/16427747#16427747
  static checkIsAvailable() {
    const e = "test";
    try {
      return r.store.setItem(e, e), r.store.removeItem(e), !0;
    } catch {
      return !1;
    }
  }
  isExpired(e) {
    return typeof e?.expire < "u" && e.expire < Date.now();
  }
  checkAllExpire(e) {
    if (this.isAvailable) {
      const t = Object.keys(r.store);
      for (const s of t)
        e !== void 0 ? e.test(s) && this.checkExpire(s) : this.checkExpire(s);
    }
  }
  checkExpire(e) {
    if (this.isAvailable) {
      const t = this.get(e);
      this.isExpired(t) && this.remove(e);
    }
  }
  /**
   *
   * @param name {string} the name of the data to store
   * @param data {Data} the data to store
   * @param [expire] how long to store the data for. If not provided the value of the `expire` property of the `data`
   * parameter will be used, if this isn't defined either a default value of 300000ms (5 minutes) will be used.
   */
  add(e, t, s = null) {
    if (this.isAvailable) {
      s === null ? t.expire = Date.now() + g : t.expire = s;
      const n = this.get(e);
      n !== null && typeof n == "object" && (t = {
        ...n,
        ...t
      }), r.store.setItem(e, JSON.stringify(t));
    }
  }
  /**
   *
   * @param name the name of the data to get
   * @param [checkExpiration = false] should the expiration be checked before returning, defaults to `false` to preserve
   * previous behavior
   * @return {Data|null}
   */
  get(e, t = !1) {
    if (this.isAvailable)
      try {
        const s = r.store.getItem(e);
        if (s === null)
          return null;
        const n = JSON.parse(s);
        return t && this.isExpired(n) ? (this.remove(e), null) : n;
      } catch {
        return null;
      }
    return null;
  }
  remove(e, t) {
    if (this.isAvailable)
      if (t !== void 0) {
        const s = this.get(e);
        typeof s == "object" && s !== null ? (delete s[t], Object.keys(s).length === 0 ? r.store.removeItem(e) : r.store.setItem(e, JSON.stringify(s))) : r.store.removeItem(e);
      } else
        r.store.removeItem(e);
  }
  has(e) {
    return this.isAvailable ? this.get(e) !== null : !1;
  }
}
const w = new r();
class c {
  isAvailable = !1;
  constructor() {
    this.isAvailable = c.checkIsAvailable();
  }
  // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available/16427747#16427747
  static checkIsAvailable() {
    const e = "test";
    try {
      return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
    } catch {
      return !1;
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  add(e, t) {
    if (this.isAvailable) {
      const s = this.get(e);
      s !== null && typeof s == "object" && (t = {
        ...s,
        ...t
      }), localStorage.setItem(e, JSON.stringify(t));
    }
  }
  get(e) {
    if (this.isAvailable)
      try {
        const t = localStorage.getItem(e);
        return t === null ? null : JSON.parse(t) ?? null;
      } catch {
        return null;
      }
  }
  remove(e, t) {
    if (!this.isAvailable)
      return;
    if (t === void 0 || t === "") {
      localStorage.removeItem(e);
      return;
    }
    const s = this.get(e);
    typeof s == "object" && s !== null ? (delete s[t], Object.keys(s).length === 0 ? localStorage.removeItem(e) : localStorage.setItem(e, JSON.stringify(s))) : localStorage.removeItem(e);
  }
}
const O = new c();
async function E(i, e, t = 3) {
  const s = new Array(i.length), n = /* @__PURE__ */ new Map();
  let o = 0;
  async function a() {
    if (o >= i.length)
      return;
    const l = o, f = i[l];
    o++;
    const h = Promise.resolve().then(() => e(f, l)).then((b) => (s[l] = b, n.delete(l), a()));
    return n.set(l, h), h;
  }
  const u = [];
  for (let l = 0; l < Math.min(t, i.length); l++)
    u.push(a());
  for (await Promise.all(u); n.size > 0; )
    await Promise.all(n.values());
  return s;
}
export {
  c as CustomLocalStorage,
  O as LocalStorageHandler,
  g as TTL_USER_INFORMATION,
  r as TempStorageService,
  w as TemporaryStorageService,
  v as bindEventListener,
  p as buildHashParameters,
  I as clamp,
  m as getHashParameters,
  d as getSiteAccess,
  y as getSiteAccessLocale,
  E as processQueue,
  A as unbindEventListener
};
//# sourceMappingURL=utils.js.map
